import React from 'react';
import { FormattedMessage } from '@kyruus/intl';
import { ProviderMatchProviderReview } from '@kyruus/types';
import Button from '@kyruus/button';
import { AnnouncedSearchResultCount } from '@kyruus/provider-components';

import {
  IndividualReviewsContainer,
  NoResultsContainer,
  IndividualReviewContainer
} from './styles';
import messages from '../../../lib/messages';
import Review from '../IndividualReview/individual-review';

interface IndividualReviewsProps {
  reviews: ProviderMatchProviderReview[];
  searchTerm?: string;
  noResults: boolean;
  onClearButtonClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const IndividualReviews = ({
  reviews,
  searchTerm,
  noResults,
  onClearButtonClick
}: IndividualReviewsProps): React.ReactElement => {
  return (
    <section>
      <AnnouncedSearchResultCount
        term={searchTerm}
        count={noResults ? 0 : reviews.length}
      />
      {noResults ? (
        <NoResultsContainer>
          <span data-testid="no-results">
            <FormattedMessage
              {...{
                ...messages.reviewsNoMatches,
                values: { term: (searchTerm || '').trim() }
              }}
            />
          </span>
          <Button
            mode="flat"
            onClick={onClearButtonClick}
            data-testid="no-results-search-term-clear-button"
          >
            <FormattedMessage {...messages.reviewsSearchInputClearButton} />
          </Button>
        </NoResultsContainer>
      ) : (
        <IndividualReviewsContainer>
          {reviews.map((r: ProviderMatchProviderReview) => (
            <IndividualReviewContainer key={r.review_id}>
              <Review review={r} searchTerm={searchTerm || ''} />
            </IndividualReviewContainer>
          ))}
        </IndividualReviewsContainer>
      )}
    </section>
  );
};

export default IndividualReviews;
